
function addGlassVariant(productId) {
//const caseType = document.getElementById(`option-template--15986787024973__main--${productId}-1-combo-box`)
const brandSelect = document.getElementById(`option-template--15986787024973__main--${productId}-1-combo-box`)

let parentDiv = document.getElementById("selectDeviceParent");
const error = document.querySelector('.error_select_device');
  
  if (!brandSelect) {
  if (parentDiv) {
    let parentForm = parentDiv.parentNode;
    parentForm.removeChild(parentDiv);
  } 

} 
const deviceSelect = document.getElementById(
  "product-device-select-template--18330820608248__main-8682713678072"
);


  if (brandSelect) {
  const brandSelectList = brandSelect.querySelector('.combo-box__option-list');
  handleAddOptionsDynamically(brandSelect);
}



// Method to append Custom Options as Buttons
function addCustomOption(optionText, optionValue, isSelected, isDisabled) {
  // Create a new <option> element
  let newOption = document.createElement('option');
  newOption.textContent = optionText;
  newOption.value = optionValue;
  
  // Set the 'selected' attribute if isSelected is true
  if (isSelected) {
    newOption.selected = true;
  }
  
  // Append the new <option> to the select element
  // const selectDevice = document.getElementById('product-device-select-template--18330820608248__main-8682713678072');
  deviceSelect.appendChild(newOption);

}
// Function to create device mapping based on brand selection
function createDeviceHashmap() {
    const modelBrandMapping = new Map();
     {
        modelBrandMapping.set("Apple", [
        "iPhone 16e",
        "iPhone 16 Pro Max",
        "iPhone 16 Pro",
        "iPhone 16 Plus",
        "iPhone 16",
        "iPhone 15 Pro Max",
        "iPhone 15 Pro",
        "iPhone 15 Plus",
        "iPhone 15",
        "iPhone 14 Pro Max",
        "iPhone 14 Pro",
        "iPhone 14 Plus",
        "iPhone 14",
        "iPhone 13 Pro Max",
        "iPhone 13 Pro",
        "iPhone 13 Mini",
        "iPhone 13",
        "iPhone 12 Pro Max",
        "iPhone 12 Pro",
        "iPhone 12 Mini",
        "iPhone 12",
        "iPhone 11 Pro Max",
        "iPhone 11 Pro",
        "iPhone 11",
        "iPhone XS Max",
        "iPhone XS",
        "iPhone XR",
        "iPhone X",
        "iPhone SE 2022",
        "iPhone SE 2020",
        "iPhone 8 Plus",
        "iPhone 8",
        "iPhone 7 Plus",
        "iPhone 7",
        "iPhone 6S Plus",
        "iPhone 6S",
        "iPhone 6 Plus",
        "iPhone 6"
        ]);


        modelBrandMapping.set("Samsung", [
        "Galaxy S24 Ultra",
        "Galaxy S24 Plus",
        "Galaxy S24 FE",
        "Galaxy S24",
        "Galaxy S23FE",
        "Galaxy S23 Ultra",
        "Galaxy S23 Plus",
        "Galaxy S23",
        "Galaxy S22 Ultra 5G",
        "Galaxy S22 Plus 5G",
        "Galaxy S22 5G",
        "Galaxy S21FE",
        "Galaxy S21 Ultra",
        "Galaxy S21 Plus",
        "Galaxy S21",
        "Galaxy S20 Ultra",
        "Galaxy S20 Plus",
        "Galaxy S20 FE 5G",
        "Galaxy S20 FE",
        "Galaxy S20",
        "Galaxy S10E",
        "Galaxy S10 Plus",
        "Galaxy S10 Lite",
        "Galaxy S10",
        "Galaxy Note 9",
        "Galaxy Note 20 Ultra",
        "Galaxy Note 20 5G",
        "Galaxy Note 20",
        "Galaxy Note 10 Plus",
        "Galaxy Note 10 Lite",
        "Galaxy Note 10",
        "Galaxy M62",
        "Galaxy M55",
        "Galaxy M54 5G",
        "Galaxy M53 5G",
        "Galaxy M52 5G",
        "Galaxy M51",
        "Galaxy M40",
        "Galaxy M35",
        "Galaxy M34 5G",
        "Galaxy M33 5G",
        "Galaxy M32 5G",
        "Galaxy M32",
        "Galaxy M31S",
        "Galaxy M31 Prime",
        "Galaxy M31",
        "Galaxy M30S",
        "Galaxy M30",
        "Galaxy M23 5G",
        "Galaxy M21 2021",
        "Galaxy M21",
        "Galaxy M20",
        "Galaxy M14",
        "Galaxy M12",
        "Galaxy M11",
        "Galaxy M10S",
        "Galaxy M10",
        "Galaxy M02S",
        "Galaxy F62",
        "Galaxy F55",
        "Galaxy F54 5G",
        "Galaxy F42 5G",
        "Galaxy F41",
        "Galaxy F34 5G",
        "Galaxy F23 5G",
        "Galaxy F22",
        "Galaxy F15",
        "Galaxy F14 5G",
        "Galaxy F12",
        "Galaxy F02S",
        "Galaxy A91",
        "Galaxy A81",
        "Galaxy A73 5G",
        "Galaxy A72",
        "Galaxy A71",
        "Galaxy A70S",
        "Galaxy A70",
        "Galaxy A60",
        "Galaxy A55",
        "Galaxy A54 5G",
        "Galaxy A53 5G",
        "Galaxy A52S 5G",
        "Galaxy A52 5G",
        "Galaxy A52",
        "Galaxy A51",
        "Galaxy A50S",
        "Galaxy A50",
        "Galaxy A40S",
        "Galaxy A40",
        "Galaxy A35",
        "Galaxy A34 5G",
        "Galaxy A33 5G",
        "Galaxy A32 5G",
        "Galaxy A32 4G",
        "Galaxy A31",
        "Galaxy A30S",
        "Galaxy A30",
        "Galaxy A25 5G",
        "Galaxy A23 5G",
        "Galaxy A22 5G",
        "Galaxy A22 4G",
        "Galaxy A20",
        "Galaxy A15 5G",
        "Galaxy A14 5G",
        "Galaxy A14 4G",
        "Galaxy A12",
        "Galaxy A11",
        "Galaxy A10S",
        "Galaxy A10",
        "Galaxy A05S",
        "Galaxy A03S",
        "Galaxy A02S",
        "Galaxy S9 Plus",
        "Galaxy S9",
        "Galaxy S8 Plus",
        "Galaxy S8"
        ]);

        modelBrandMapping.set("Google", [
          "Pixel 9 Pro XL",
          "Pixel 9 Pro",
          "Pixel 9",
          "Pixel 8A",
          "Pixel 8 Pro",
          "Pixel 8",
          "Pixel 7A",
          "Pixel 7 Pro",
          "Pixel 7",
          "Pixel 6A",
          "Pixel 6 Pro",
          "Pixel 6"
        ]);

        modelBrandMapping.set("OnePlus", [
        "Oneplus Ace Racing",
        "Oneplus Ace Pro 5G",
        "Oneplus Ace 5G",
        "Oneplus Ace 2V",
        "Oneplus Ace 2 5G",
        "Oneplus 12R",
        "Oneplus 12",
        "Oneplus 11R 5G",
        "Oneplus 11 5G",
        "Oneplus 10T 5G",
        "Oneplus 10R",
        "Oneplus 10 Pro 5G",
        "Oneplus 9RT",
        "Oneplus 9R",
        "Oneplus 9 Pro",
        "Oneplus 9",
        "Oneplus 8T",
        "Oneplus 8 Pro",
        "Oneplus 8",
        "Oneplus 7T Pro",
        "Oneplus 7T",
        "Oneplus 7 Pro",
        "Oneplus 7",
        "Oneplus 6T",
        "Oneplus 6",
        "Oneplus 5T",
        "Oneplus Nord N20 5G",
        "Oneplus Nord CE 4 Lite 5G",
        "Oneplus Nord CE 5G",
        "Oneplus Nord CE 4",
        "Oneplus Nord CE 3 Lite",
        "Oneplus Nord CE 3 5G",
        "Oneplus Nord CE 2 Lite 5G",
        "Oneplus Nord CE 2 5G",
        "Oneplus Nord 4",
        "Oneplus Nord 3 5G",
        "Oneplus Nord 2T 5G",
        "Oneplus Nord 2",
        "Oneplus Nord",
        ]);

        modelBrandMapping.set("Vivo / IQOO", [
          "Vivo IQOO 10",
          "Vivo IQOO 11",
          "Vivo IQOO 12",
          "Vivo IQOO 3",
          "Vivo IQOO 7",
          "Vivo IQOO 7 Legend 5G",
          "Vivo IQOO 8 5G",
          "Vivo IQOO 9 5G",
          "Vivo IQOO 9 5G International",
          "Vivo IQOO 9 Pro 5G",
          "Vivo IQOO 9 SE 5G",
          "Vivo IQOO 9T 5G",
          "Vivo IQOO Neo 5",
          "Vivo IQOO Neo 5 S",
          "Vivo IQOO Neo 6 5G",
          "Vivo IQOO Neo 7",
          "Vivo IQOO Neo 7 Pro",
          "Vivo IQOO Neo 6 SE",
          "Vivo IQOO Neo 7 Racing",
          "Vivo IQOO Neo 7 SE",
          "Vivo IQOO Neo 9",
          "Vivo IQOO Neo9 Pro",
          "Vivo IQOO U5E",
          "Vivo IQOO Z3",
          "Vivo IQOO Z5",
          "Vivo IQOO Z6",
          "Vivo IQOO Z6 International",
          "Vivo IQOO Z6 Lite",
          "Vivo IQOO Z6 Pro 5G",
          "Vivo IQOO Z6X",
          "Vivo IQOO Z7",
          "Vivo IQOO Z7 International",
          "Vivo IQOO Z7 Pro 5G",
          "Vivo IQOO Z7S",
          "Vivo IQOO Z9",
          "Vivo IQOO Z9 Lite",
          "Vivo IQOOz9X",
          "Vivo S1",
          "Vivo S1 Pro",
          "Vivo S1 Pro International",
          "Vivo S10E",
          "Vivo S12",
          "Vivo S12 Pro",
          "Vivo S15 Pro",
          "Vivo S15E",
          "Vivo S16",
          "Vivo S16 Pro",
          "Vivo S16E",
          "Vivo S18",
          "Vivo S18 Pro",
          "Vivo S7",
          "Vivo T1 5G",
          "Vivo T1 Pro 5G",
          "Vivo T2 5G",
          "Vivo T2 Pro 5G",
          "Vivo T2X 5G International",
          "Vivo T3 5G",
          "Vivo T3X",
          "Vivo V15 Pro",
          "Vivo V17",
          "Vivo V17 Pro",
          "Vivo V19",
          "Vivo V20",
          "Vivo V20 Pro",
          "Vivo V20 SE",
          "Vivo V21",
          "Vivo V21 5G",
          "Vivo V21E",
          "Vivo V21S",
          "Vivo V23 5G",
          "Vivo V23 Pro 5G",
          "Vivo V23E 5G",
          "Vivo V25 5G",
          "Vivo V25 Pro 5G",
          "Vivo V25E",
          "Vivo V27",
          "Vivo V27 Pro",
          "Vivo V27E",
          "Vivo V29",
          "Vivo V29 Pro",
          "Vivo V29E",
          "Vivo V30",
          "Vivo V30 Pro",
          "Vivo V30E",
          "Vivo V40",
          "Vivo V40 Pro",
          "Vivo X100",
          "Vivo X100 Pro",
          "Vivo X60",
          "Vivo X60 Pro",
          "Vivo X60T",
          "Vivo X70",
          "Vivo X70 Pro",
          "Vivo X80 5G",
          "Vivo X80 Lite",
          "Vivo X80 Pro 5G",
          "Vivo X90",
          "Vivo X90 Pro",
          "Vivo Y03",
          "Vivo Y100",
          "Vivo Y100 International",
          "Vivo Y100A",
          "Vivo Y16",
          "Vivo Y18E",
          "Vivo Y200",
          "Vivo Y200 Pro",
          "Vivo Y200E",
          "Vivo Y200T",
          "Vivo Y22",
          "Vivo Y22S",
          "Vivo Y27",
          "Vivo Y28S",
          "Vivo Y30 5G",
          "Vivo Y33E",
          "Vivo Y33S 5G",
          "Vivo Y35",
          "Vivo Y35+ 5G",
          "Vivo Y36",
          "Vivo Y38",
          "Vivo Y52 5G",
          "Vivo Y52T",
          "Vivo Y55 5G",
          "Vivo Y56 5G",
          "Vivo Y70",
          "Vivo Y72 5G International",
          "Vivo Y73",
          "Vivo Y73T",
          "Vivo Y75 5G",
          "Vivo Y75S",
          "Vivo Z1 Pro",
          "Vivo Z1X",
          "Vivo Z5X"
        ]);

        modelBrandMapping.set("Oppo", [
        "Oppo A1 Pro",
        "Oppo A11",
        "Oppo A11X",
        "Oppo A3 Pro",
        "Oppo A3 Pro International",
        "Oppo A5 2020",
        "Oppo A58 International",
        "Oppo A58X",
        "Oppo A59",
        "Oppo A73 2020",
        "Oppo A74",
        "Oppo A78 5G",
        "Oppo A79",
        "Oppo A9 2020",
        "Oppo A91",
        "Oppo A93",
        "Oppo A94",
        "Oppo A96 International",
        "Oppo F11 Pro",
        "Oppo F15",
        "Oppo F17",
        "Oppo F17 Pro",
        "Oppo F19",
        "Oppo F19 Pro",
        "Oppo F19 Pro Plus",
        "Oppo F21 Pro 4G",
        "Oppo F21 Pro 5G",
        "Oppo F21S Pro 4G",
        "Oppo F21S Pro 5G",
        "Oppo F23 5G",
        "Oppo F25 Pro",
        "Oppo F27 Pro Plus",
        "Oppo Find N3 Back",
        "Oppo Find N3 Front",
        "Oppo K12",
        "Oppo K3",
        "Oppo K5",
        "Oppo Reno 10 5G",
        "Oppo Reno 10 Pro 5G",
        "Oppo Reno 10 Pro Plus 5G",
        "Oppo Reno 10X Zoom",
        "Oppo Reno 11",
        "Oppo Reno 11 Pro",
        "Oppo Reno 12 5G",
        "Oppo Reno 12 Pro 5G",
        "Oppo Reno 2",
        "Oppo Reno 2F",
        "Oppo Reno 2Z",
        "Oppo Reno 3",
        "Oppo Reno 3 Pro International",
        "Oppo Reno 4 Lite",
        "Oppo Reno 4 Pro",
        "Oppo Reno 4F",
        "Oppo Reno 5 Pro",
        "Oppo Reno 6 5G",
        "Oppo Reno 6 Pro 5G",
        "Oppo Reno 7 5G",
        "Oppo Reno 7 Pro 5G",
        "Oppo Reno 8 5G",
        "Oppo Reno 8 Pro 5G",
        "Oppo Reno 8T 5G",
        "Oppo Reno Ace",
        "Oppo Reno5 F",
        "Oppo Reno5 Lite",
        "Oppo Reno7",
        "Oppo Reno7 Lite",
        "Oppo Reno7 Z 5G",
        "Oppo Reno8 4G",
        "Oppo Reno8 Lite",
        "Oppo Reno8 Z"
        ]);

        modelBrandMapping.set("Nothing Phone", [
          "Nothing Phone 2a",
          "Nothing CMF Phone 1",
          "Nothing Phone 2",
          "Nothing Phone 1",
        ]);


        modelBrandMapping.set("Realme", [
        "Realme XT",
        "Realme X7 Pro",
        "Realme X7 Max 5G",
        "Realme X7 International",
        "Realme X50 Pro",
        "Realme X2 Pro",
        "Realme X2",
        "Realme X Lite",
        "Realme X",
        "Realme V25",
        "Realme V13 5G",
        "Realme Q5 Pro",
        "Realme Q5",
        "Realme Q3I 5G",
        "Realme Q3 Pro 5G",
        "Realme Q3 5G",
        "Realme Q2 Pro International",
        "Realme P1",
        "Realme Narzo 70X",
        "Realme Narzo 70 Pro",
        "Realme Narzo 70",
        "Realme Narzo 60X 5G",
        "Realme Narzo 60 Pro",
        "Realme Narzo 60",
        "Realme Narzo 50 Pro",
        "Realme Narzo 30 5G",
        "Realme Narzo 20 Pro",
        "Realme Narzo 10",
        "Realme GT Neo6",
        "Realme GT Neo 2T",
        "Realme GT Neo Flash",
        "Realme GT Neo 6 Se",
        "Realme GT Neo 3T",
        "Realme GT Neo 3",
        "Realme GT Neo 2",
        "Realme GT 6T",
        "Realme GT 6",
        "Realme GT 5G",
        "Realme GT 2 Pro",
        "Realme GT 2",
        "Realme C65 5G",
        "Realme 9I 4G",
        "Realme 9 Pro Plus 5G",
        "Realme 9 Pro 5G",
        "Realme 9 5G Speed Edition",
        "Realme 9 5G",
        "Realme 9 4G",
        "Realme 8S 5G",
        "Realme 8 Pro",
        "Realme 8 5G",
        "Realme 8",
        "Realme 7 Pro",
        "Realme 7",
        "Realme 6S",
        "Realme 6I",
        "Realme 6 Pro",
        "Realme 6",
        "Realme 5S",
        "Realme 5 Pro",
        "Realme 5",
        "Realme 3 Pro",
        "Realme 13 Pro Plus",
        "Realme 13 Pro",
        "Realme 12X",
        "Realme 12 Pro Plus",
        "Realme 12 Pro",
        "Realme 12 Plus",
        "Realme 12",
        "Realme 11X 5G",
        "Realme 11 Pro+",
        "Realme 11 Pro",
        "Realme 11 International",
        "Realme 11 5G",
        "Realme 10 Pro Plus 5G",
        "Realme 10 Pro 5G"
        ]);

        modelBrandMapping.set("Motorola", [  
          "Motorola Edge 50 Ultra",
          "Motorola Edge 50 Pro",
          "Motorola Edge 50 Fusion",
          "Motorola Edge 50",
          "Motorola Edge 40 Neo",
          "Motorola Edge 40",
          "Motorola Edge 30 Ultra",
          "Motorola Edge 30 Fusion",
          "Motorola Edge 30",
          "Motorola Moto G85 5G",
          "Motorola Moto G84",
          "Motorola Moto G64",
          "Motorola Moto G54"
        ]);

        modelBrandMapping.set("Xiaomi / Redmi / Poco", [  
          "Xiaomi Redmi Note 9S",
          "Xiaomi Redmi Note 9 Pro Max",
          "Xiaomi Redmi Note 9 Pro 5G",
          "Xiaomi Redmi Note 9 Pro",
          "Xiaomi Redmi Note 9",
          "Xiaomi Redmi Note 8 Pro",
          "Xiaomi Redmi Note 8 2021",
          "Xiaomi Redmi Note 8",
          "Xiaomi Redmi Note 7S",
          "Xiaomi Redmi Note 7 Pro",
          "Xiaomi Redmi Note 7",
          "Xiaomi Redmi Note 13 Pro Plus",
          "Xiaomi Redmi Note 13 Pro",
          "Xiaomi Redmi Note 13",
          "Xiaomi Redmi Note 12 Pro Plus",
          "Xiaomi Redmi Note 12 Pro",
          "Xiaomi Redmi Note 12 5G",
          "Xiaomi Redmi Note 12 4G",
          "Xiaomi Redmi Note 11T Pro Plus",
          "Xiaomi Redmi Note 11T Pro",
          "Xiaomi Redmi Note 11T 5G",
          "Xiaomi Redmi Note 11Se 5G International",
          "Xiaomi Redmi Note 11S 5G",
          "Xiaomi Redmi Note 11S",
          "Xiaomi Redmi Note 11E Pro",
          "Xiaomi Redmi Note 11 Se",
          "Xiaomi Redmi Note 11 Pro+ 5G",
          "Xiaomi Redmi Note 11 Pro Plus 5G International",
          "Xiaomi Redmi Note 11 Pro 5G International",
          "Xiaomi Redmi Note 11 Pro",
          "Xiaomi Redmi Note 11 International",
          "Xiaomi Redmi Note 11",
          "Xiaomi Redmi Note 10T 5G",
          "Xiaomi Redmi Note 10S",
          "Xiaomi Redmi Note 10 Pro Max",
          "Xiaomi Redmi Note 10 Pro",
          "Xiaomi Redmi Note 10 Lite",
          "Xiaomi Redmi Note 10 5G",
          "Xiaomi Redmi Note 10",
          "Xiaomi Redmi K50I",
          "Xiaomi Redmi K40 Gaming",
          "Xiaomi Redmi K40",
          "Xiaomi Redmi K30I 5G",
          "Xiaomi Redmi K30",
          "Xiaomi Redmi K20 Pro",
          "Xiaomi Redmi K20",
          "Xiaomi Redmi 9T",
          "Xiaomi Redmi 9 Power",
          "Xiaomi Redmi 7A",
          "Xiaomi Redmi 13C 5G",
          "Xiaomi Redmi 13 5G",
          "Xiaomi Redmi 12 5G",
          "Xiaomi Redmi 12 4G",
          "Xiaomi Redmi 10X 4G",
          "Xiaomi Poco X6 Pro",
          "Xiaomi Poco X6",
          "Xiaomi Poco X5 Pro 5G",
          "Xiaomi Poco X5 5G",
          "Xiaomi Poco X5",
          "Xiaomi Poco X4 Pro 5G",
          "Xiaomi Poco X4 Gt",
          "Xiaomi Poco X3 Pro",
          "Xiaomi Poco X3 Nfc",
          "Xiaomi Poco X3",
          "Xiaomi Poco X2",
          "Xiaomi Poco M6 Pro 5G",
          "Xiaomi Poco M5S",
          "Xiaomi Poco M4 Pro 5G",
          "Xiaomi Poco M3 Pro 5G",
          "Xiaomi Poco M2 Pro",
          "Xiaomi Poco F6",
          "Xiaomi Poco F5 5G",
          "Xiaomi Poco F4 5G",
          "Xiaomi Poco F3 Gt",
          "Xiaomi Poco F3",
          "Xiaomi Poco F1",
          "Xiaomi Mi Note 10 International",
          "Xiaomi Mi A3",
          "Xiaomi Mi 9T Pro",
          "Xiaomi Mi 9T",
          "Xiaomi Mi 11X Pro",
          "Xiaomi Mi 11X",
          "Xiaomi Mi 11 Ultra",
          "Xiaomi Mi 10T Pro",
          "Xiaomi Mi 10T Lite 5G",
          "Xiaomi Mi 10T",
          "Xiaomi Mi 10I",
          "Xiaomi 14 Ultra",
          "Xiaomi 14",
          "Xiaomi 13 Pro",
          "Xiaomi 12X",
          "Xiaomi 12S Pro",
          "Xiaomi 12 Pro 5G",
          "Xiaomi 12 Lite 5G",
          "Xiaomi 11T Pro 5G",
          "Xiaomi 11T 5G",
          "Xiaomi 11I Hypercharge 5G",
          "Xiaomi 11I 5G",
          "Xiaomi 11 Lite Ne 5G",
          "Xiaomi 11 Lite"
        ]);
      
        modelBrandMapping.set("Flip / Fold / Open", [
            "Oneplus Open",
            "Samsung Galaxy Z Fold 6",
            "Samsung Galaxy Z Fold 5",
            "Samsung Galaxy Z Fold 4",
            "Samsung Galaxy Z Fold 3",
            "Samsung Galaxy Z Flip 6",
            "Samsung Galaxy Z Flip 5",
            "Samsung Galaxy Z Flip 4",
            "Samsung Galaxy Z Flip 3"
        ]);
    } 
      

    return modelBrandMapping
}

function handleAddOptionsDynamically(brandSelectDropDownRef) {
  if (brandSelectDropDownRef) {

    // Get the list of button elements inside the combo box
    
    const brandSelectOptions = brandSelectDropDownRef.querySelectorAll('.combo-box__option-item');

    brandSelectOptions.forEach(function (option) {
      if (option.textContent.trim() === "Select") {
        option.setAttribute('aria-selected', 'true');
        option.disabled = true;
        deviceSelect.disabled = true;
      }
    });

    // Create HashMap to store models for each brand
    const modelBrandMapping = createDeviceHashmap();
    
    // Add event listener for handling option changes
    document.addEventListener("click", function (e) {
      if (e.target.matches('.combo-box__option-item')) {
        const selectedBrandButton = e.target;
        let selectedBrandValue = selectedBrandButton.textContent;
        const options = brandSelect.querySelectorAll('.combo-box__option-item');
        options.forEach((option, index) => {    
            if(option.textContent == selectedBrandValue){
              option.setAttribute('aria-selected',true)
            }
        });
        if(!modelBrandMapping.has(selectedBrandValue)){
          //addCustomOption("Select","Select",true,true)
          if (options.length > 0) {
            let currentlySelectedOption = null;
            options.forEach((option, index) => {
                // Check if the option is currently selected
                if (option.getAttribute('aria-selected') === 'true') {
                    currentlySelectedOption = option; // Store the currently selected option
                }
            });
            if(currentlySelectedOption){
              selectedBrandValue = currentlySelectedOption.textContent
            }
          }
          
        }
       
        if (selectedBrandValue !== "Select") {
           // Clear the device select list
          deviceSelect.innerHTML = "";
          const devices = modelBrandMapping.get(selectedBrandValue);
          error.hidden = true;
          
          if (devices) {
            devices.forEach(function addOptions(device) {
              addCustomOption(device, device, false, false);
            });
          }
          deviceSelect.disabled = false;
        }
      }
    });
  }
}

}